import { useEffect, useState } from "react";
import { useCurrentUser } from "@/src/auth/hooks/use-current-user";
import { childcareConfigService } from "@/src/childcare/services/childcare-config.service";

interface UseChildcareAccessResult {
	hasAccess: boolean;
	isLoading: boolean;
}

/**
 * Whether the current user can reach the staff/admin childcare section. Backed by
 * the `has_childcare_access()` RPC so the answer always matches the RLS boundary.
 */
export function useChildcareAccess(): UseChildcareAccessResult {
	const user = useCurrentUser();
	const [hasAccess, setHasAccess] = useState(false);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		if (!user) {
			setHasAccess(false);
			setIsLoading(false);
			return;
		}
		let cancelled = false;
		setIsLoading(true);
		void childcareConfigService
			.hasChildcareAccess()
			.then((value) => {
				if (!cancelled) setHasAccess(value);
			})
			.catch(() => {
				if (!cancelled) setHasAccess(false);
			})
			.finally(() => {
				if (!cancelled) setIsLoading(false);
			});
		return () => {
			cancelled = true;
		};
	}, [user]);

	return { hasAccess, isLoading };
}
